import React from "react";
import { Comment, Row, Col, Timeline, Popover } from "antd";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

type TimelineItemProps = {
  id: number;
  author: string;
  change: string;
  timestamp: Date;
};

type Props = {
  timelineEntries: TimelineItemProps[];
};

export const MatterEditorVersions: React.FC<Props> = ({ timelineEntries }) => {
  return (
    <Row style={{ width: "100%", padding: "5px", paddingTop: "24px" }}>
      <Col span={24}>
        <Timeline mode="right">
          {timelineEntries.map(({ id, author, change, timestamp }) => (
            <Timeline.Item label={dayjs(timestamp).fromNow()} key={id}>
              <Popover
                placement="leftTop"
                content={
                  <Comment
                    author={<a>{author}</a>}
                    content={
                      <div>
                        <p>{change}</p>
                      </div>
                    }
                    datetime={<span>{dayjs(timestamp).format("DD-MM-YYYY HH:mm")}</span>}
                  />
                }
                trigger="click"
              >
                <span style={{ cursor: "pointer" }}>{change}</span>
              </Popover>
            </Timeline.Item>
          ))}
        </Timeline>
      </Col>
    </Row>
  );
};
